import React, { useEffect } from 'react';
import {
    Box,
    Grid,
    Paper,
    Autocomplete,
    Typography,
    TextField,

} from '@mui/material';
import { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import CustomButton from '../../components/Buttons';
import HeaderComponent from '../../components/Header';
import CustomCard from '../../components/UIComponents/CustomCard';
import TableData from './table';
import { createBlockList, fetchBlockingReason, fetchRoomBlockingList, fetchRoomList, updateBlockList } from '../../service/network';
import StyledAutocomplete from '../../components/UIComponents/StyledAutocomplete';
import theme from '../../assets/theme';
import { useLoading } from '../../context/loading.context';
import StyledTextField from '../../components/UIComponents/StyledTextField';
import RoomBlockingPopup from './Popups/RoomBlockingPopup';
import moment from 'moment/moment';
import { useNotification } from "../../context/notification.context";
import { mergeReportData } from '../../helpers/functions';
import CommonTable from '../../components/Table/CommonTable';
import { Upload } from '@mui/icons-material';
import * as XLSX from 'xlsx';

export default function RoomBlockingList() {
    const [filters, setFilters] = useState({
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().add(6, 'days').format('YYYY-MM-DD'),
        room_no: '',
        status: '',
    });

    const { roomBlockList, roomBlockHeader } = TableData();
    const { showLoader, hideLoader } = useLoading();
    const [addopenPopup, setAddOpenPopup] = useState(false);
    const [editOpenPopup, setEditOpenPopup] = useState(false);
    const [viewOpenPopup, setViewOpenPopup] = useState(false);
    const [blockList, setBlockList] = useState([]);
    const [reasonList, setReasonList] = useState([]);
    const [dialogMode, setDialogMode] = useState('add');
    const { showNotification } = useNotification();
    const [selectrowId, setSelectrowId] = useState(null);
    const [rooms, setRooms] = useState([])


    const [formData, setFormData] = useState({
        room_no: '',
        reason: '',
        description: '',
        date_time: '',
        from_date: '',
        to_date: ''
    });

    const handleFilterChange = (name, value) => {
        console.log("filters", filters);
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddClick = () => {
        setFormData({
            room_no: '',
            reason: '',
            description: '',
            date_time: '',
            from_date: '',
            to_date: ''
        });
        setAddOpenPopup(true);
        setDialogMode("add");
    };

    const handleEditClick = (rowData) => {
        setFormData({
            id: rowData.request_id,
            room_no: rowData.room_no,
            description: rowData.description || '',
            from_date: rowData.from_date,
            to_date: rowData.to_date,
            reason: rowData.reason,
        });
        setEditOpenPopup(true);
        setDialogMode("edit");
    };


    const exportToExcel = () => {
        if (!blockList || blockList.length === 0) {
            alert("No data available to export.");
            return;
        }

        const rows = roomBlockList(blockList) 
        console.log("formReservationListRows", rows)

        const exportData = rows.map((row) => ({
            Request_ID: row.request_id,
            Room_No: row.room_name,
            Reason: row.reason,
            Status: row.details?.status || '', 
            From_Date: row.from_date || '', 
            To_Date: row.to_date|| '',
            Description: row.description,
        }));

        // Convert to worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // Optional: Set column widths
        worksheet['!cols'] = [
            { wch: 15 },
            { wch: 12 },
            { wch: 20 },
            { wch: 10 },
            { wch: 15 },
            { wch: 20 },
            { wch: 20 },
        ];

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Maintenance");

        // Save
        XLSX.writeFile(workbook, "maintenance_data.xlsx");
    };



    const fetchRooms = async () => {
        try {
            showLoader()
            const roomListParams = {
                doctype: 'Room',
                fields: JSON.stringify(["room_name", "type", "status", "info", "name"]),
            };

            const response = await fetchRoomList(roomListParams);

            const { keys, values } = response.data.message;
            const roomData = values.map(row =>
                keys.reduce((acc, key, i) => {
                    acc[key] = row[i];
                    return acc;
                }, {})
            );
            console.log("roomData", roomData)

            setRooms(roomData);
        } catch (err) {
            console.error("Failed to fetch initial data", err);
        } finally {
            hideLoader()
        }
    };

    const fetchBlockingReasons = async () => {
        try {
            showLoader();
            const blockReasonParams = {
                doctype: 'Block Reason',
                fields: JSON.stringify(["name", "reason_name"])
            };
            const reasonResp = await fetchBlockingReason(blockReasonParams);
            const { keys, values } = reasonResp.data.message;
            const formattedReasonData = values.map(row =>
                keys.reduce((acc, key, i) => {
                    acc[key] = row[i];
                    return acc;
                }, {})
            );
            setReasonList(formattedReasonData);
            console.log("formattedReasonData", formattedReasonData);
        } catch (err) {
            console.error("Failed to fetch initial data", err);
        } finally {
            hideLoader();
        }
    };



    useEffect(() => {
        fetchRooms();
        fetchBlockingReasons();
    }, []);

    useEffect(() => {
        fetchRoomBlocking();
    }, [filters])

    const fetchRoomBlocking = async () => {
        try {
            showLoader();
            const filterConditions = [];

            if (filters.fromDate) {
                filterConditions.push(['from_date', '<=', moment(filters.toDate).format("YYYY-MM-DD HH:mm:ss ")]);
            }

            if (filters.toDate) {
                filterConditions.push(['to_date', '>=', moment(filters.fromDate).format("YYYY-MM-DD HH:mm:ss")]);
            }
            if (filters.room_no) {
                filterConditions.push(['room', '=', filters.room_no?.name]);
            }

            if (filters.status) {
                filterConditions.push(['status', '=', filters.status]);
            }

            const roomBlockingParams = {
                doctype: 'Room Blockings',
                fields: JSON.stringify(["name", "room", "room.room_name", "reason", "status", "from_date", "to_date", "description"]),
                ...(filterConditions.length > 0 && { filters: JSON.stringify(filterConditions) }),
            };
            const response = await fetchRoomBlockingList(roomBlockingParams);
            console.log("Api Response", response.data.message);
            if (response.data.message && (!Array.isArray(response.data.message))) {
                let merge_blockingList = mergeReportData(response.data.message.keys, response.data.message.values);
                setBlockList(merge_blockingList);
                console.log("merge_blockingList", merge_blockingList);
            } else {
                setBlockList([]);
            }
            console.log("RoomBlockingResponse", response.data.message);

        } catch (error) {
            showNotification('error', 'Error', error.message);
        } finally {
            hideLoader();
        }
    };

  const createRoomBlockDetails = async (data) => {
    try {
        showLoader();
        const payload = {
            doc: JSON.stringify({
                doctype: "Room Blockings",
                room: data.room_no.name || '',
                reason: data.reason?.name || '',
                from_date: data.from_date,
                to_date: data.to_date,
                status: data.status,
                description: data.description || ''
            }),
            action: "Save"
        };

        console.log("payload", payload);

        const response = await createBlockList(payload);

        if (!response?.data) {
            throw new Error(response?.data?.message || 'Failed to create Room Block');
        }

        showNotification("success", "Success", "Successfully Created");
        console.log("API response:", response.data);
        setAddOpenPopup(false);
        fetchRoomBlocking();
        setSelectrowId(null);

    } catch (error) {
        console.error('Error creating room block:', error);

        let errorMessage = 'Failed to create Room Block';

        if (error.response?.data?._server_messages) {
            try {
                const messages = JSON.parse(error.response.data._server_messages);
                errorMessage = messages.map(msg => {
                    try {
                        const parsed = JSON.parse(msg);
                        return parsed.message.replace(/<[^>]+>/g, '');
                    } catch {
                        return msg;
                    }
                }).join(', ');
            } catch (parseError) {
                console.error('Error parsing server messages:', parseError);
            }
        } else if (error.message) {
            errorMessage = error.message;
        }

        showNotification('error', 'Error', errorMessage);
    } finally {
        hideLoader();
    }
};


    const updateRoomBlockDetails = async (data) => {
        try {
            showLoader();
            const payload = {
                doctype: "Room Blockings",
                ...(data)
            }

            const response = await updateBlockList(selectrowId, payload);
            if (!response?.data) {
                throw new Error("Invalid response structure");
            }
            showNotification("success", "Updated", "Successfully Updated");
            console.log("API response:", response.data);
            setEditOpenPopup(false);
            fetchRoomBlocking()
            setSelectrowId(null);

        } catch (error) {
            let errorMessage = 'Failed to update Room Block';

            if (error.response?.data?._server_messages) {
                try {
                    const messages = JSON.parse(error.response.data._server_messages);
                    errorMessage = messages.map(msg => {
                        try {
                            const parsed = JSON.parse(msg);
                            return parsed.message.replace(/<[^>]+>/g, '');
                        } catch {
                            return msg;
                        }
                    }).join(', ');
                } catch (parseError) {
                    console.error('Error parsing server messages:', parseError);
                }
            } else if (error.message) {
                errorMessage = error.message;
            }

            showNotification('error', 'Error', error.message);
        } finally {
            hideLoader();
        }
    };

    const saveRoomBlockEntry = async (data) => {
        try {
            showLoader();
            if (dialogMode === "add") {
                console.log("Creating roomBlocking Entry:", data);
                await createRoomBlockDetails(data);
            } else {
                console.log("updating roomBlocking Entry:", data);
                await updateRoomBlockDetails(data)
            }
        } catch (err) {
            console.error("Failed to save roomBlocking entry", err);
        } finally {
            hideLoader();
        }
    };


    return (
        <Box sx={{ width: '100%', p: 2 }}>
            <HeaderComponent title="Room Blocking List" />
            <RoomBlockingPopup
                open={addopenPopup}
                onClose={() => setAddOpenPopup(false)}
                onSave={(data) => {
                    console.log("Saved roomBlocking Data:", data);
                    saveRoomBlockEntry(data);

                }}
                formData={formData}
                setFormData={setFormData}
                issueCategories={reasonList}
                roomsOptions={rooms}
                mode={dialogMode}
            />
            <RoomBlockingPopup
                open={editOpenPopup}
                onClose={() => setEditOpenPopup(false)}
                onSave={(data) => {
                    saveRoomBlockEntry(data);

                }}
                formData={formData}
                setFormData={setFormData}
                issueCategories={reasonList}
                roomsOptions={rooms}
                mode={dialogMode}
            />


            <CustomCard
                bgColor="light"
                shadow="lg"
                borderRadius="xxl"
                sx={{
                    width: '100%',
                    minHeight: 800,
                    borderTopLeftRadius: 0,
                }}
            >
                <Grid container spacing={2} justifyContent="flex-end">
                    {/* Action Buttons */}
                    <Grid item xs={12} md={6}  >
                        <Box display='flex' gap={2}>
                            

                        </Box>
                    </Grid>
                </Grid>

                <Grid container spacing={0.8} mt={3}>
                    <Grid item size={{ xs: 6, md: 2 }}>
                        <StyledTextField
                            value={filters.fromDate}
                            label="From Date"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                            inputProps={{
                                max: filters.toDate
                            }}
                        />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 2 }}>
                        <StyledTextField
                            value={filters.toDate}
                            label="To Date"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleFilterChange('toDate', e.target.value)}
                            inputProps={{
                                min: filters.fromDate
                            }}
                        />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 2 }}>
                        <Typography
                            variant="bodyText1"
                            sx={{ color: 'dark.main', mb: 0.5 }}
                        >
                            Room No.
                        </Typography>
                        <Autocomplete
                            fullWidth
                            options={rooms}
                            value={filters.room_no}

                            onChange={(e, newValue) => handleFilterChange('room_no', newValue)}
                            getOptionLabel={(option) => option.room_name || ""}
                            PaperComponent={(props) => (
                                <Paper
                                    {...props}
                                    sx={{
                                        '& .MuiAutocomplete-option:hover': {
                                            backgroundColor: '#E1EFFF !important',
                                        },
                                        borderRadius: '8px',
                                        backgroundColor: 'lightred.main',
                                    }}
                                />
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Room No."
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: theme.borderRadius.medium,
                                            backgroundColor: 'lightgray.main',
                                        },
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 6, md: 5 }} ml="auto">
                        <Box display="flex" justifyContent="flex-end" mt={2.7} gap={1} >
                            <CustomButton
                                variant="outlined"
                                startIcon={<Upload />}
                                sx={{
                                    borderColor: 'primary.main',
                                    hegiht: 36,
                                    color: 'primary.main',
                                    borderRadius: theme.borderRadius.medium,
                                    border: "2px solid var(--Primary-Blue-MB, #27394D)",
                                    textTransform: 'none',
                                    '&:hover': { borderColor: 'primary.dark' },
                                }}
                                onClick={exportToExcel}
                            >
                                Export
                            </CustomButton>
                            <CustomButton
                                variant="outlined"
                                startIcon={<AddIcon />}
                                onClick={handleAddClick}
                                sx={{
                                    color: 'light.main',
                                    borderRadius: theme.borderRadius.medium,
                                    backgroundColor: 'primary.main',
                                    textTransform: 'none',
                                    '&:hover': { borderColor: 'primary.dark' },
                                }}
                            >
                                Add Room Block
                            </CustomButton>
                        </Box>
                    </Grid>

                </Grid>
                <Box sx={{ mt: 3 }}>
                    <CommonTable
                        backgroundColor={'light.main'}
                        disableElevation={true}
                        data={{
                            rows: roomBlockHeader,
                            columns: roomBlockList(blockList),
                        }}
                        onRowClick={(rowData) => {
                            console.log("clickrow", rowData)
                            setSelectrowId(rowData.request_id);
                            handleEditClick(rowData);
                        }}
                    />
                </Box>

            </CustomCard>
        </Box >
    );
}